import { Controller } from "@hotwired/stimulus"
import { loadChart } from "../lib/load_chart"

export default class extends Controller {
  static values = {
    labels: Array,
    data: Array,
    questionsLabel: { type: String, default: "questions" }
  }

  async connect() {
    this.Chart = await loadChart()
    if (this.element.isConnected) this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const ctx = this.element
    const data = this.dataValue
    const lastIndex = data.length - 1

    // Highlight today's bar with success color
    const backgroundColors = data.map((_, i) =>
      i === lastIndex ? "rgba(32, 201, 151, 0.8)" : "rgba(98, 125, 152, 0.6)"
    )
    const borderColors = data.map((_, i) =>
      i === lastIndex ? "rgb(32, 201, 151)" : "rgb(98, 125, 152)"
    )

    const questionsLabel = this.questionsLabelValue

    this.chart = new this.Chart(ctx, {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: [{
          data: data,
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1,
          borderRadius: 3
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (context) => `${context.parsed.y} ${questionsLabel}`
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
              callback: (value) => Number.isInteger(value) ? value : null
            },
            grid: { color: "rgba(98, 125, 152, 0.1)" }
          },
          x: {
            grid: { display: false }
          }
        }
      }
    })
  }
}
